module.exports = __webpack_public_path__ + "static/img/logo@3x.09fc25d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/logo@3x.png
// module id = QF9w
// module chunks = 0